import React from "react";
import { makeStyleguideTemplate } from "tsi-common-react/src/styleguide/makeStyleguideTemplate";

import { templates } from "@reactivated";

import { offerContentComponentsMap } from "../blocks/offerContentComponentsMap";
import { toolboxComponentsMap } from "../blocks/toolboxComponentsMap";
import { offerDetailContentComponentsMap } from "../components/OfferDetailPageBody";
import { StyleguideChrome } from "../components/StyleguideChrome";

// Each key is a production block dispatcher a page-body assembly uses, so a
// routed fixture renders through the same serialize + StreamField path a real
// page does: `toolbox`/`offer` are the ToolboxContent / OfferContent bodies;
// `offer_detail` is the OfferDetailPage `content` body, whose `FAQs` / anchor
// keys render the stearns-local StearnsFAQsBlock / StearnsAnchorBlock (distinct
// from the toolbox `faqs_block`). None close over page-derived state, so no
// zeroed factory is needed.
const registry = {
    toolbox: toolboxComponentsMap,
    offer: offerContentComponentsMap,
    offer_detail: offerDetailContentComponentsMap,
};

const StyleguideBlocks = makeStyleguideTemplate(registry);

export const Template = (
    props: templates.StyleguideBlockTemplate,
): React.JSX.Element => {
    const inner = (
        <StyleguideBlocks
            block={props.block}
            map_key={props.map_key}
            bg_color={props.bg_color}
        />
    );
    return (
        <StyleguideChrome storybook={props.storybook}>
            {props.storybook ? inner : <div id="block-tester">{inner}</div>}
        </StyleguideChrome>
    );
};
